import { render, staticRenderFns } from "./recordModal.vue?vue&type=template&id=20980e75&scoped=true"
import script from "./recordModal.vue?vue&type=script&lang=js"
export * from "./recordModal.vue?vue&type=script&lang=js"
import style0 from "./recordModal.vue?vue&type=style&index=0&id=20980e75&prod&lang=scss&scoped=true"
import style1 from "./recordModal.vue?vue&type=style&index=1&id=20980e75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20980e75",
  null
  
)

export default component.exports